import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
export const PollVotes = ({ votes }) => {
    if (votes === 0)
        return _jsx(FormattedMessage, { id: "POLLS_VOTES_NUMBER_WEB.zero" });
    if (votes === 1)
        return _jsx(FormattedMessage, { id: "POLLS_VOTES_NUMBER_WEB.one" });
    return (_jsx(FormattedMessage, { id: "POLLS_VOTES_NUMBER_WEB.other", values: { votes } }));
};
//# sourceMappingURL=poll-votes.js.map